import type { NotificationInstance } from 'antd/es/notification/interface';

export const NOTIFY_DURATION_SECONDS = 4;
export const NOTIFY_MAX_COUNT = 3;

export function createNotifier(notification: NotificationInstance) {
  return {
    success: (message: string, description?: string) =>
      notification.success({ message, description, placement: 'topRight' }),
    error: (message: string, description?: string) =>
      notification.error({ message, description, placement: 'topRight' }),
    info: (message: string, description?: string) =>
      notification.info({ message, description, placement: 'topRight' }),
  };
}
